/* unplugin-vue-components disabled */import script from "./lectureCardNew.vue?vue&type=script&setup=true&lang=js"
export * from "./lectureCardNew.vue?vue&type=script&setup=true&lang=js"

import "./lectureCardNew.vue?vue&type=style&index=0&id=0bfb4af8&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfb4af8"]])

export default __exports__